import React, { useState } from 'react';

import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { Alert, Col, FormGroup, Label, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { UpwardLoadingButton } from 'ui';
import { Checkbox, EmailInput, PasswordInput } from 'ui-blocks/form-elements';
import { loginUserSuccessPartner } from 'redux/auth/authActions';
import { logInPartner } from '../services/authPartners';
import config from './config';
import { resolvePostLoginRedirect } from 'util/auth/postLoginRedirect';
import { getLoginErrorMessage } from '../loginErrorMessage';

const SignInForm = (props) => {
   const history = useHistory();
   const location = useLocation();
   const [errorMessage, setErrorMessage] = useState();

   return (
      <Formik
         initialValues={ {
            username: '',
            password: '',
            rememberMe: true,
         } }
         validateOnChange={ false }
         validateOnBlur={ false }
         validationSchema={ Yup.object({
            username: Yup.string()
               .email()
               .required(),
            password: Yup.string()
               .required(),
            rememberMe: Yup.bool(),
         }) }
         onSubmit={ (values, { setSubmitting }) => {
            setErrorMessage(undefined);
            logInPartner(values)
               .subscribe((res = {}) => {
                  if (res?.token && !(res?.error)) {
                     props?.loginUserSuccessPartner({
                        token: res?.token,
                     });

                     history.push(resolvePostLoginRedirect(location?.state?.from, config.SUCCESS_LOGIN_URL_REDIRECT));
                  } else {
                     setErrorMessage(getLoginErrorMessage(res?.status));
                     setSubmitting(false);
                  }
               });
         } }
      >
         {
            (formik) => {
               return (
                  <Form>
                     {
                        errorMessage
                        && (
                           <Alert
                              color='danger'
                              style={ {
                                 color: '#fff',
                                 backgroundColor: '#e51c23',
                              } }
                           >
                              { errorMessage }
                           </Alert>
                        )
                     }
                     <FormGroup>
                        <Label>Email</Label>
                        <Field
                           name='username'
                           component={ EmailInput }
                           bsSize='lg'
                        />
                     </FormGroup>
                     <FormGroup>
                        <Label>Password</Label>
                        <Field
                           name='password'
                           bsSize='lg'
                           component={ PasswordInput }
                        />
                     </FormGroup>
                     <FormGroup className='d-flex align-items-center mt-1'>
                        <Field
                           name='rememberMe'
                           component={ Checkbox }
                        />
                        <Label
                           style={ {
                              fontFamily: 'apercu-extralight',
                              fontSize: '0.85rem',
                              paddingLeft: '6px',
                           } }
                        >
                           Remember me next time
                        </Label>
                     </FormGroup>
                     <div className='text-center mt-4'>
                        <Row noGutters>
                           <Col
                              xs={ {
                                 size: '4',
                                 offset: '4',
                              } }
                           >
                              <UpwardLoadingButton
                                 type='submit'
                                 color='primary'
                                 size='lg'
                                 block
                                 className='btn-dark-orange btn-rounded'
                                 isLoading={ formik.isSubmitting }
                              >
                                 Sign In
                              </UpwardLoadingButton>
                           </Col>
                        </Row>
                     </div>
                  </Form>
               );
            }
         }
      </Formik>
   );
};

const mapDispatchToProps = (dispatch) => ({
   loginUserSuccessPartner: (data) => (dispatch(loginUserSuccessPartner(data))),
});

export default connect(
   null,
   mapDispatchToProps,
)(SignInForm);
